import { render, staticRenderFns } from "./ViewCampaigne.vue?vue&type=template&id=7605b7ca&"
import script from "./ViewCampaigne.vue?vue&type=script&lang=js&"
export * from "./ViewCampaigne.vue?vue&type=script&lang=js&"
import style0 from "./ViewCampaigne.vue?vue&type=style&index=0&id=7605b7ca&lang=css&"
import style1 from "./ViewCampaigne.vue?vue&type=style&index=1&id=7605b7ca&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7605b7ca')) {
      api.createRecord('7605b7ca', component.options)
    } else {
      api.reload('7605b7ca', component.options)
    }
    module.hot.accept("./ViewCampaigne.vue?vue&type=template&id=7605b7ca&", function () {
      api.rerender('7605b7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/ViewCampaigne.vue"
export default component.exports